import React from 'react';
import { format } from 'date-fns';
import { Chip, Tooltip, Box, Typography } from '@mui/material';

const truncateText = (text: string, maxLength = 50) => {
  if (!text) return '-';
  return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
};

export const customerIssuesColumns = () => [
  {
    name: 'Customer',
    selector: (row) => row.customer,
    sortable: true,
    grow: 2,
    cell: (row) => (
      <Tooltip title={row.customer || ''} arrow>
        <span>{truncateText(row.customer, 40)}</span>
      </Tooltip>
    ),
  },
  {
    name: 'Status',
    selector: (row) => row.resolved,
    sortable: true,
    width: '110px',
    cell: (row) => (
      <Chip
        label={row.is_resolved ? 'Resolved' : 'Open'}
        color={row.is_resolved ? 'success' : 'warning'}
        size="small"
      />
    ),
  },
  {
    name: 'Age',
    selector: (row) => row.age,
    sortable: true,
    width: '80px',
    cell: (row) => `${row.age}d`,
  },
  {
    name: 'Opened',
    selector: (row) => row.opened,
    sortable: true,
    width: '110px',
    cell: (row) => (row.opened ? format(new Date(row.opened), 'MM/dd/yy') : '-'),
  },
  {
    name: 'Type',
    selector: (row) => row.issue_type,
    sortable: true,
    grow: 1,
    cell: (row) => (
      <Tooltip title={row.issue_type || ''} arrow>
        <span>{truncateText(row.issue_type, 20)}</span>
      </Tooltip>
    ),
  },
  {
    name: 'Source',
    selector: (row) => row.source,
    sortable: true,
    width: '110px',
  },
  {
    name: 'Assigned',
    selector: (row) => row.assigned,
    sortable: true,
    grow: 1,
    cell: (row) => row.assigned || '-',
  },
  {
    name: 'Location',
    selector: (row) => row.db_location,
    sortable: true,
    width: '100px',
    cell: (row) => (
      <Chip
        label={row.db_location === 'pittsburgh' ? 'PGH' : 'TPA'}
        color={row.db_location === 'pittsburgh' ? 'primary' : 'secondary'}
        size="small"
      />
    ),
  },
];
